module.exports = __webpack_public_path__ + "img/select_profile.2891aa17.png";